




























































import Vue from 'vue';
import { Component, Prop, Ref } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

@Component<EmailChallenge>({})
export default class EmailChallenge extends Vue {
  @Prop({ type: String })
  email: string;

  @Ref('form')
  form: InstanceType<typeof ValidationObserver>;

  async checkExistEmail(): Promise<void> {
    const response = await this.$http.post('/authentication/staff/send-otp', {
      email: this.email,
    });
    const staff = response.data;
    console.log(response);
    if (!staff) {
      this.form.setErrors({
        email: this.$t('forgotPassword.isNotExist', {
          _field_: 'Email',
        }) as string,
      });
    } else {
      this.$router.push('/forgot-password/otp-challenge');
    }
  }
}
